import { useForm } from "react-hook-form";
import TextField from "../../../components/UI/TextField";
import { useMapStore } from "../../../store/mapStore";
import { Plus } from "react-feather";
import { useEffect, useState } from "react";
import { missionPlanningByJamwant } from "../../../api/missionAPI";
import { useMutation } from "@tanstack/react-query";
import { useAuthStore } from "../../../store/authStore";

const MissionPlanning = ({ setWaypoints }) => {
    const { setLoaderState } = useAuthStore((state) => state)
    const { setShowMissionPlanningPopup } = useMapStore((state) => state);

    const autmatedWaypoints = useMutation({
        mutationFn: missionPlanningByJamwant,
        onSuccess: () => {
            // refetch on submit
        },
    });

    const [reqObjectFormat, setReqObjectFormat] = useState({
        startPoint: [0, 0],
        endPoint: [0, 0]
    })

    const handleSubmit = () => {
        setLoaderState(true)
        autmatedWaypoints.mutate(reqObjectFormat)

    }

    useEffect(() => {
        if (autmatedWaypoints?.data?.data?.path.length > 0) {
            setLoaderState(false)
            const formattedWaypoints = autmatedWaypoints?.data?.data?.path?.map((item) => {
                return { lat: item[0].toString(), lng: item[1].toString(), alt: "100" }
            })
            setWaypoints(formattedWaypoints);
            setShowMissionPlanningPopup(false)
        }
    }, [autmatedWaypoints?.data?.data])

    return (
        <>
            <div className="grid place-items-center w-screen h-screen fixed z-50 bg-black/25 backdrop-blur-sm inset-0">
                <div id="defaultModal" className="p-4 overflow-x-hidden overflow-y-auto md:inset-0">
                    <div className="relative w-full max-w-xl max-h-fit">
                        <div className="relative bg-white rounded-lg dark:bg-white" >
                            <div className="flex items-start justify-between p-4 rounded-t dark:border-gray-600">

                                <span>
                                    <h3 className="text-3xl font-semibold text-gray-900 dark:text-black capitalize">
                                        Automated Mission Planning
                                    </h3>
                                </span>
                                <button onClick={() => { setShowMissionPlanningPopup(false) }} type="button" className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-red-500 dark:hover:text-white" data-modal-hide="defaultModal">
                                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                    <span className="sr-only">Close modal</span>
                                </button>
                            </div>
                            <div className="p-4 pt-1 w-full flex flex-wrap">
                                <div className="pr-2">
                                    <span className="">
                                        <div>
                                            <h1 className="text-tblu text-xl mb-1">Starting Position :</h1>
                                        </div>
                                        <div className="flex">
                                            <TextField
                                                placeholder={"Latitude"}
                                                label="Latitude"
                                                inputProps={{
                                                    onChange: (event) => {
                                                        // Handle the change event here
                                                        setReqObjectFormat((prev) => ({
                                                            ...prev,
                                                            startPoint: [parseFloat(event.target.value), prev.startPoint[1]]
                                                        }));
                                                    }
                                                }}
                                            />
                                            &ensp;
                                            <TextField
                                                placeholder={"Longitude"}
                                                label="Longitude"
                                                inputProps={{
                                                    onChange: (event) => {
                                                        // Handle the change event here
                                                        setReqObjectFormat((prev) => ({
                                                            ...prev,
                                                            startPoint: [prev.startPoint[0], parseFloat(event.target.value)]
                                                        }));
                                                    }
                                                }}
                                            />


                                        </div>
                                        <div>
                                            <h1 className="text-tblu text-xl mb-1 mt-3">Ending Position :</h1>
                                        </div>
                                        <div className="flex">
                                            <TextField
                                                placeholder={"Latitude"}
                                                label="Latitutde"
                                                inputProps={{
                                                    onChange: (event) => {
                                                        // Handle the change event here
                                                        setReqObjectFormat((prev) => ({
                                                            ...prev,
                                                            endPoint: [parseFloat(event.target.value), prev.endPoint[0]]
                                                        }));
                                                        // Do something with the new value
                                                    }
                                                    // ...waypointForm.register("lat", { required: true }),
                                                }}
                                            />
                                            &ensp;
                                            <TextField
                                                placeholder={"Longitude"}
                                                label="Longitude"
                                                inputProps={{
                                                    onChange: (event) => {
                                                        // Handle the change event here
                                                        setReqObjectFormat((prev) => ({
                                                            ...prev,
                                                            endPoint: [prev.endPoint[0], parseFloat(event.target.value)]
                                                        }));
                                                        // Do something with the new value
                                                    }
                                                    // ...waypointForm.register("lng", { required: true }),
                                                }}
                                            />

                                        </div>
                                        <div className="flex justify-center">

                                            <button
                                                onClick={handleSubmit}
                                                className="rounded-xl bg-tblu p-4 text-white mt-6"
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </span>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MissionPlanning;